import { useThemeProvider } from "@towersystems/roam-common-native";
import { useEffect, useState } from "react";
import { Animated, View } from "react-native";

export interface CameraPreviewPreparingProps {
  showChildren: boolean;
  children?: React.ReactNode;
}

const READY_OPACITY = 0;
const UNREADY_OPACITY = 1;
const DURATION = 300;

/**
 * Fade in children
 */
export function OpaqueOverlay({
  showChildren,
  children,
}: CameraPreviewPreparingProps) {
  const { colors } = useThemeProvider();
  const [_animated] = useState(
    new Animated.Value(showChildren ? READY_OPACITY : UNREADY_OPACITY)
  );

  useEffect(() => {
    if (!showChildren) {
      return;
    }

    Animated.timing(_animated, {
      toValue: READY_OPACITY,
      duration: DURATION,
      useNativeDriver: true,
    }).start();
  }, [showChildren]);

  const opacityTransitionStyle = { opacity: _animated };

  const commonFullScreenStyle = {
    display: "flex",
    width: "100%",
    height: "100%",
  } as const;

  return (
    <View style={commonFullScreenStyle}>
      <Animated.View
        style={[
          {
            ...commonFullScreenStyle,
            position: "absolute",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: colors.black,
          },
          opacityTransitionStyle,
        ]}
      />
      {children}
    </View>
  );
}
